import React from 'react';

interface IProgressProps {
    // slots
    title: string;
    subtitle?: string;
    // attributes
    currentStep: number;
    dark?: boolean;
    hiddenTitle?: boolean;
    percentage: number; // [2, 98]
    steps?: number;
    stepsOnly?: boolean;
    // extra nous
    subtitleDataTestId?: string;
}

export const Progress: React.FC<IProgressProps> = ({
    // slots
    title,
    subtitle = ' ',
    // attributes
    currentStep = 0,
    dark = false,
    hiddenTitle = false,
    percentage,
    steps = 0,
    stepsOnly = false,
    // extra nous
    subtitleDataTestId
}) => (
    // @ts-ignore
    <dsd-progress
        percentage={percentage}
        current-step={currentStep}
        steps={steps}
        steps-only={stepsOnly}
        hidden-title={hiddenTitle}
        dark={dark}
    >
        <span slot="title">{title}</span>
        <span slot="subtitle" data-testid={subtitleDataTestId}>
            {subtitle}
        </span>
        {/* @ts-ignore */}
    </dsd-progress>
);
